<script>
  import PapaParse from "papaparse"
  import {
    btn_style_orange_d2,
    btn_style_yellow_d3,
    btn_style_teal,
    btn_style_blue_d3,
  } from "../etc/helpers"
  import { selectedLanguage } from "../etc/store.js"

  export let onUpload

  export let dataToCSV = []
  let prevDataToCSV

  // Only allow CSV file type to upload
  export let allowedFileExtensions = ["csv"]

  // 3M bytes
  //  let maxFileSize = 3145728

  // 2K bytes about 0.5 ~ 1 page of text. Assumming each uploaded gua record is 1 page long.
  // max gua: 100 ~ 200 = 200K
  let maxFileSize = 204800

  // this is the variable that the file gets bound to
  let uploader

  $: {
    // called on props change
    if (dataToCSV !== prevDataToCSV && dataToCSV.length !== 0) {
      prevDataToCSV = dataToCSV
      const csvData = PapaParse.unparse(dataToCSV)
      onUpload ? onUpload(csvData) : console.log("")
      //   "Remember to define an onUpload function as props. CSV Data:",
      //   csvData
      // )
    }
  }

  function uploadFile(event) {
    event.preventDefault()
    const file = uploader.files[0]

    const fileExtensionArray = file.type.split("/")
    const fileExtension = fileExtensionArray[fileExtensionArray.length - 1]

    if (file.size > maxFileSize) {
      // console.log("Above the max file size threshold")
      return
    }
    if (fileExtension.includes("csv") && file.size < maxFileSize) {
      const csvData = PapaParse.parse(file, {
        complete: (results) => {
          onUpload ? onUpload(results.data) : console.log("")
          //   "Remember to define an onUpload function as props. Parsed CSV:",
          //   results.data
          // )
        },
      })
    } else if (allowedFileExtensions.includes(fileExtension)) {
      onUpload ? onUpload(file) : console.log("")
      //   "Remember to define an onUpload function as props. Plain file:",
      //   file
      // )
    } else {
      // console.log("Not an allowed file type")
    }
  }
</script>

<input
  hidden
  id="btn-upload"
  bind:this={uploader}
  on:change={uploadFile}
  type="file"
/>
<label class={btn_style_orange_d2} for="btn-upload"
  >{$selectedLanguage == "TW" ? "卦例上傳" : "卦例上传"}</label
>

<style>
  .btn-single {
    margin-bottom: 8px;
  }
</style>
